import React, { Component } from 'react'
import { Input } from 'antd'
import { I18n } from 'react-redux-i18n'
import cx from 'classnames'

import SearchIcon from '../../icons/search.svg'
import CloseIcon from '../../icons/close.svg'

class CompositionSearch extends Component {
  constructor (props) {
    super(props)

    this.state = {
      searchText: ''
    }
  }

  triggerSearch (searchText) {
    this.props.onSearch(searchText)
    this.props.fetchCompositions(true)
  }

  handleClear () {
    this.setState({searchText: ''})
    this.triggerSearch('')
  }

  handleCompositionSearch () {
    const textLength = this.state.searchText.length
    if (!textLength || textLength >= 3) {
      this.triggerSearch(this.state.searchText)
    }
  }

  handleChange (e) {
    this.setState({searchText: e.currentTarget.value})
  }

  render () {
    const searchAddon = (
      <div onClick={this.handleCompositionSearch.bind(this)} className='qw-cursor-pointer'>
        <SearchIcon className='qw-icon-medium'/>
      </div>
    )
    const {searchText} = this.state
    return (
      <div className={cx('composition-search-holder qw-relative', {'has-clear': !!searchText})}>
        <Input
          placeholder={I18n.t('compositions.searchPlaceholder')}
          value={searchText}
          className='composition-search qw-border qw-not-rounded qw-font-size-body'
          onPressEnter={this.handleCompositionSearch.bind(this)}
          onChange={this.handleChange.bind(this)}
          addonAfter={searchAddon}
        />
        {searchText && <div className='composition-search-clear' onClick={this.handleClear.bind(this)}>
          <CloseIcon className='qw-icon-medium'/></div>}
      </div>
    )
  }
}

export default CompositionSearch



// WEBPACK FOOTER //
// ./src/app/components/compositions/CompositionSearch.js